import { render } from "./LicencePieChart.vue?vue&type=template&id=fdd14d2a"
import script from "./LicencePieChart.vue?vue&type=script&lang=js"
export * from "./LicencePieChart.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Florian\\Work\\Sportips\\NOUVEAUX MODULES\\inscription\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__